const img = require('./estrela.svg');
const img2 = require('./lupa.svg');
const img3 = require('./pin.svg');

export const icons = {
  estrela: img,
  lupa: img2,
  pin: img3,
};
